import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { GET_CUSTOMERS_QUERY_KEY } from '~/features/customers/hooks/useGetCustomers'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { supabaseApi } from '~/supabase/api'
import { Customer } from '~/supabase/types'

export type CustomerPayload = Omit<Customer, 'id' | 'created_at'>

export const useCreateNewCustomer = () => {
  const queryClient = useQueryClient()

  const { mutate: notifyError } = useNotifyError()

  return useMutation({
    mutationKey: ['create-customer'] as const,
    mutationFn: async (payload: CustomerPayload) => {
      const { error } = await supabaseApi.from('customers').insert(payload)

      if (error) {
        toast.error('Customer could not be created')
        notifyError({
          error,
          message: 'Customer could not be created',
          function: 'useCreateNewCustomer',
          data: { payload },
        })
        throw error
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CUSTOMERS_QUERY_KEY] })
      toast.success('Customer successfully created')
    },
  })
}
